module.exports = __webpack_public_path__ + "img/anime.f04d94cd.png";